import { takeLatest, call, put } from 'redux-saga/effects'
import getMyCertificate, { GetMyCertificateRequest } from 'api/certificates/Get'
import * as fromActions from 'store/actions/certificates.action'

async function getCertificateInfo(params: GetMyCertificateRequest) {
  return getMyCertificate(params)
}

function* getMyCertificateEffectSaga(action: any) {
  try {
    const data = yield call(getCertificateInfo, action.payload)
    yield put(fromActions.Actions.getMyCertificateSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* getMyCertificateWatcherSaga() {
  yield takeLatest(fromActions.GET_MY_CERTIFICATE, getMyCertificateEffectSaga)
}
